module.exports = __webpack_public_path__ + "static/media/map-pin.e57647ba.svg";